import { createSelector } from 'reselect';

import { getNavigation } from './MasterSetupPageSelectors';

export const getBulkImport = (state) => state.bulkImport;

export const getImportEntities = createSelector(
  getBulkImport,
  (bulkImport) => bulkImport?.importEntities
);

export const getImportEntityProp = (entityName, propName) =>
  createSelector(getImportEntities, (importEntities) => importEntities[entityName]?.[propName]);

export const getIsImportModalOpen = createSelector(
  getBulkImport,
  (bulkImport) => bulkImport?.isModalOpen || false
);

export const getStepIdProp = (entityName) =>
  createSelector(getNavigation, (navigation) => {
    let stepId = '';

    if (Array.isArray(navigation)) {
      navigation.forEach((navItem) => {
        const templateData = navItem?.contentInfos?.menu?.contentData?.templateData;
        if (Array.isArray(templateData)) {
          templateData.forEach((data) => {
            const links = data?.Links;
            if (Array.isArray(links)) {
              const linkData = links.find((link) => link.EntityName === entityName);
              if (linkData) {
                stepId = linkData.StepId;
              }
            }
          });
        }
      });
    }

    return stepId;
  });
